import { useEffect, useState } from 'react';

import { getModifierKeys, type ModifierKey } from '@paragon/utilities';

export function useModifierKey(modifierKey: ModifierKey) {
  const [held, setHeld] = useState(false);

  useEffect(() => {
    const onModifierEvent = (event: KeyboardEvent | MouseEvent) => void setHeld(getModifierKeys(event)[modifierKey]);
    const onBlur = () => void setHeld(false);
    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') setHeld(false);
    };

    document.addEventListener('keydown', onModifierEvent);
    document.addEventListener('keyup', onModifierEvent);
    document.addEventListener('mousemove', onModifierEvent);
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('blur', onBlur);

    return () => {
      document.removeEventListener('keydown', onModifierEvent);
      document.removeEventListener('keyup', onModifierEvent);
      document.removeEventListener('mousemove', onModifierEvent);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('blur', onBlur);
    };
  }, [modifierKey]);

  return held;
}
